import React, { Suspense } from 'react';
import {createRoot} from 'react-dom/client';
import './scss/style.css';
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom';
import { AppProvider } from './context';
import './i18'

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// 👇️ wrap App in Router
root.render(
  <Suspense fallback={<div>Loading...</div>}>
    <AppProvider>
    <Router>
      <App />
    </Router>
  </AppProvider>
  </Suspense>
);
